var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83144 5.0594C1.72531 4.95327 1.58578 4.89989 1.4465 4.89989C1.30723 4.89989 1.1677 4.95327 1.06157 5.0594C0.848741 5.27223 0.848741 5.61644 1.06157 5.82927L4.17268 8.94038C4.38551 9.15321 4.72972 9.15321 4.94255 8.94038L8.05366 5.82927C8.26649 5.61644 8.26649 5.27223 8.05366 5.0594C7.84083 4.84657 7.49662 4.84657 7.28379 5.0594L4.55761 7.78558L1.83144 5.0594Z",
    fill: "#3E3F42",
    stroke: "#3E3F42",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10391 1.33588C5.10391 1.20481 5.0334 1.09359 4.93395 1.01849C4.83458 0.943439 4.70182 0.9 4.55946 0.9C4.4171 0.9 4.28435 0.943438 4.18497 1.01849C4.08553 1.09359 4.01502 1.20481 4.01502 1.33588L4.01502 8.66412C4.01502 8.79506 4.08556 8.90625 4.18495 8.98137C4.2843 9.05645 4.41705 9.1 4.55946 9.1C4.70188 9.1 4.83463 9.05645 4.93398 8.98137C5.03337 8.90625 5.10391 8.79506 5.10391 8.66412L5.10391 1.33588Z",
    fill: "#3E3F42",
    stroke: "#3E3F42",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingArrowDown);
export default __webpack_public_path__ + "static/media/sorting-arrow-down.ad0dd0039951195f7c450c777ac477f4.svg";
export { ForwardRef as ReactComponent };